const WITHDRAWAL_LISTS = new Set(['/app/v1/withdrawals', '/app/v1/withdrawals/admin']);
const BALANCE_KEYS = new Set([
  '/app/v1/balances',
  '/app/v1/balances/partners',
  '/app/v1/withdrawals/limits',
]);

/** SWR keys that must refresh after a withdrawal is created. */
export const isCabinetBalanceOrWithdrawalKey = (key: unknown): boolean => {
  if (typeof key === 'string') {
    return BALANCE_KEYS.has(key);
  }

  return Array.isArray(key) && typeof key[0] === 'string' && WITHDRAWAL_LISTS.has(key[0]);
};
